import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@shared/auth/auth.service';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { map, catchError, filter } from 'rxjs/operators';
import { BASE_NOMINATIM_URL, DEFAULT_VIEW_BOX } from '../constants/app.constants';
import 'rxjs/add/observable/of';
import domToImage from 'dom-to-image';
import jsPDF, { jsPDFOptions } from 'jspdf';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';

@Injectable()
export class UtilityService {
  requestDownloadSubject = new BehaviorSubject<boolean>(false);
  requestDownloadSubject$ = this.requestDownloadSubject.asObservable();

  constructor(private translate: TranslateService,private authService:AuthService,private http: HttpClient) {
  }
  getValueMap(value?:number):string{
    const v = value || -1;
    return environment?.user?.mapping[Math.round(v)] || 'nd';
  }
  requestDownload(){
    this.requestDownloadSubject.next(true);
  }
  downloadPagePdf(element, pdfInfo) {
    const width = element.nativeElement.clientWidth;
    const height = element.nativeElement.clientHeight + 40;
    let imageUnit = 'portrait';
    
    domToImage
      .toPng(element.nativeElement, {
        width: width,
        height: height
      })
      .then(result => {
        const jsPdfOptions:jsPDFOptions = {
          format: [width + 50, height + 220],
          orientation: width > height? 'l' : 'p'
        };
        const pdf = new jsPDF(jsPdfOptions);
         pdf.setFontSize(72);
         pdf.setTextColor('#2585fe');
         pdf.text(this.translate.instant("DOWNLOAD.DASHBOARD_TITLE"), 25, 75);
         pdf.setFontSize(32);
         pdf.setTextColor('#000');
         pdf.text(this.translate.instant("DOWNLOAD.INFO") + pdfInfo, 25, 115);
        pdf.addImage(result, 'PNG', 25, 185, width, height);
        pdf.save(this.translate.instant("DOWNLOAD.NAME") + '.pdf');
      })
      .catch(error => {
      });
  }


  private addressRequest = [];
  addAddressRequest(index){
    this.addressRequest.push({
      index: index,
      ready:false
    });
    if(this.addressRequest.length == 1)
    this.addressRequestSubject.next(this.addressRequest[0]);
  }
  removeAddressRequest(index){
    const el = this.addressRequest.find(C=>C.index == index);
    this.addressRequest.splice(index, 1);
    if(this.addressRequest.length > 1)
    this.addressRequestSubject.next(this.addressRequest[0]);
  }
  addressRequestSubject = new BehaviorSubject<any>(this.addressRequest);
  addressRequestSubject$ = this.addressRequestSubject.asObservable();


  public currentItems: Array<any> = [];
  currentItemSubject = new BehaviorSubject<Array<any>>(this.currentItems);
  reloadDataSubject = new BehaviorSubject<boolean>(false);
  currentItemSubject$ = this.currentItemSubject.asObservable();
  reloadDataSubject$ = this.reloadDataSubject.asObservable();
  
  getAuthImg(path):string{
    return this.authService.getAuthImgPath(path);
  }
  reloadAllData(){
    this.reloadDataSubject.next(true);
  }
  showImagesDialog(items?) {
    if(items)this.currentItems = items;
    this.currentItemSubject.next(this.currentItems);
  }
  addressLookup(req?: any): Observable<NominatimResponse[]> {
    let url = `https://${BASE_NOMINATIM_URL}/search?format=json&q=${req}&${DEFAULT_VIEW_BOX}&bounded=1`;
    return this.http
      .get(url)
      .pipe(
        catchError((error: HttpErrorResponse) =>{
            return Observable.of(new NominatimResponse('0','0', req));
        }),
        map((data: any[]) => data.map((item: any) => new NominatimResponse(
          item.lat,
          item.lon,
          item.display_name
          ))
        )
        
      )
      
  }
  getLocation(val:string, inverted?){
    val = val.replace('POINT(','').replace(')','').replace(' ',',');
    return !inverted?
     [
            Number(val.split(',')[0]), 
            Number(val.split(',')[1])
          ]
      :
      [ 
            Number(val.split(',')[1]), 
            Number(val.split(',')[0])
          ];
    }
  formatDate(date) {
      var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
      if (month.length < 2) 
          month = '0' + month;
      if (day.length < 2) 
          day = '0' + day;
  
      return [year, month, day].join('-');
  }
  convertLineStringToPoints(lineString:string){
    const s = lineString.replace('LINESTRING','').replace(')','').replace('(','');
    const a = s.split(',');
    let arr = [];
    a.forEach(c=>{
      const pos = c.split(' ');
      arr.push('POINT(' + c + ')');
    })
    return arr;
  }
  getColorScore(n:number,alpha?:number){
    const score = Math.round(n);
    const map = environment.user.colors;
    if(map && map[score]){
      const c = map[score];
      return 'rgba(' + c[0] +','+c[1]+','+c[2]+',' + (alpha || 1) + ')';
    }else {
      if(map[map.length-1]){
        const c  = map[map.length];
        return 'rgba(' + c[0] +','+c[1]+','+c[2]+',' + (alpha || 1) + ')';
      }
      else return 'rgba(255,255,255)';
    }
  }
}
export class NominatimResponseWrap {
  constructor(
    public id: string,
    public response: NominatimResponse,
  ) { }
}
export class NominatimResponse {
  constructor(
    public latitude: string,
    public longitude: string,
    public displayName: string
  ) { }
}